import { extendTheme } from '@chakra-ui/react';

export const POKER_COLORS = {
  darkTeal: '#0D3847',
  cyan: '#00D9D9',
  gold: '#FFD700',
  darkGreen: '#2E8B57',
  darkRed: '#8B0000',
  accentCyan: '#00B8CC',
  darkBg: '#0A1F2E',
  cardBg: '#162A38',
};

const theme = extendTheme({
  colors: {
    poker: {
      ...POKER_COLORS,
    },
  },
  styles: {
    global: {
      body: {
        bg: POKER_COLORS.darkBg,
        color: 'white',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: '8px',
        transition: 'all 0.2s',
      },
      variants: {
        poker_primary: {
          bg: POKER_COLORS.cyan,
          color: POKER_COLORS.darkTeal,
          _hover: {
            bg: POKER_COLORS.accentCyan,
            transform: 'scale(1.02)',
            boxShadow: `0 0 20px ${POKER_COLORS.cyan}`,
          },
          _active: {
            transform: 'scale(0.98)',
          },
        },
        poker_secondary: {
          bg: POKER_COLORS.darkTeal,
          color: POKER_COLORS.cyan,
          border: `2px solid ${POKER_COLORS.cyan}`,
          _hover: {
            boxShadow: `0 0 12px ${POKER_COLORS.cyan}`,
            bg: `${POKER_COLORS.darkTeal}dd`,
          },
        },
        poker_danger: {
          bg: POKER_COLORS.darkRed,
          color: 'white',
          _hover: {
            bg: '#A00000',
            boxShadow: `0 0 12px ${POKER_COLORS.darkRed}`,
          },
        },
        poker_success: {
          bg: POKER_COLORS.darkGreen,
          color: 'white',
          _hover: {
            bg: '#3E9B6F',
            boxShadow: `0 0 12px ${POKER_COLORS.darkGreen}`,
          },
        },
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: POKER_COLORS.cyan,
      },
      variants: {
        poker: {
          field: {
            bg: `${POKER_COLORS.darkTeal}33`,
            border: `2px solid ${POKER_COLORS.cyan}`,
            color: POKER_COLORS.cyan,
            _focus: {
              boxShadow: `0 0 12px ${POKER_COLORS.cyan}`,
              borderColor: POKER_COLORS.cyan,
            },
            _placeholder: {
              color: 'gray.500',
            },
          },
        },
      },
    },
  },
});

export default theme;